"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogPatternController = void 0;
const ParentController_1 = __importDefault(require("../ParentController"));
class CatalogPatternController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/catalog',
            edit: '/v1/catalog/:objectId',
            delete: '/v1/catalog/:objectId',
        };
    }
}
exports.CatalogPatternController = CatalogPatternController;
